import { useTranslation } from "react-i18next";
import { Box } from "@chakra-ui/react";
import BackButton from "src/components/BackButton";
import { H2, H3, BodyText } from "src/atoms/typography";
import ScrollBox from "src/atoms/ScrollBox/index";
import IconOnBackground from "src/components/IconOnBackground";
import { ReactComponent as PairingIcon } from "./2-devices.svg";
import { ReactComponent as PremiumIcon } from "./premium.svg";
import { ReactComponent as DevicesIcon } from "./devices.svg";

export default function WhatIsFamilyAccount({ flow }) {
  const { t } = useTranslation();
  return (
    <Box pt="47px" pb="24px" height="100%">
      <ScrollBox textAlign="center">
        <Box mx="auto" maxWidth="320px">
          <BackButton absolute onClick={flow.previous} />
          <H2 color="highEmphasis">{t("whatIsFamilyAccount")}</H2>
          <BodyText mt="8px" color="mediumEmphasis">
            {t("purchase.whatIsFamilyAccount.text")}
          </BodyText>

          <IconOnBackground
            mt="24px"
            mx="auto"
            bg="primaryLight"
            icon={PairingIcon}
            fill="primaryLighter"
          />
          <H3 color="highEmphasis" mt="8px">
            {t("purchase.whatIsFamilyAccount.pairing.heading")}
          </H3>
          <BodyText mt="8px" mb="24px" color="mediumEmphasis">
            {t("purchase.whatIsFamilyAccount.pairing.text")}
          </BodyText>

          <IconOnBackground
            mx="auto"
            bg="tint2Light"
            fill="tint2"
            icon={PremiumIcon}
          />
          <H3 color="highEmphasis" mt="8px">
            {t("purchase.whatIsFamilyAccount.subscription.heading")}
          </H3>
          <BodyText mt="8px" mb="24px" color="mediumEmphasis">
            {t("purchase.whatIsFamilyAccount.subscription.text")}
          </BodyText>

          <IconOnBackground
            mx="auto"
            bg="tint3Light"
            fill="tint3"
            icon={DevicesIcon}
          />
          <H3 color="highEmphasis" mt="8px">
            {t("purchase.whatIsFamilyAccount.platforms.heading")}
          </H3>
          <BodyText mt="8px" color="mediumEmphasis">
            {t("purchase.whatIsFamilyAccount.platforms.text")}
          </BodyText>
        </Box>
      </ScrollBox>
    </Box>
  );
}
